const API_BASE_URL = '/api';

export const API_ENDPOINTS = {
  CONTACT: `${API_BASE_URL}/contact`,
};
